import usePWAInstall from "../../Hooks/usePWAInstall";
import styles from "./InstallButton.module.css";

export default function InstallButton({ compact = false }) {
  const { installApp, canInstall } = usePWAInstall();

  const isIOS = /iphone|ipad|ipod/i.test(navigator.userAgent);

  const isStandalone =
    window.matchMedia('(display-mode: standalone)').matches ||
    window.navigator.standalone === true;

  // 👉 MODO COMPACTO (Sidebar/Header) — NÃO MEXE
  if (compact) {
    if (!canInstall) return null;

    return (
      <button className={styles.smallButton} onClick={installApp}>
        📲 Instalar
      </button>
    );
  }

  // 👉 MODO COMPLETO (Home)
  return (
    <div className={styles.wrapper}>

      {/* ✔ Botão (Android/Desktop) */}
      {!isStandalone && canInstall && (
        <button className={styles.button} onClick={installApp}>
          📲 Instalar App
        </button>
      )}

      {/* ✔ Mensagem quando já está instalado */}
      {isStandalone && (
        <div className={styles.installedText}>
          ✅ Você já está usando a versão app
        </div>
      )}

      {/* 🍎 iOS (único com instrução) */}
      {!isStandalone && isIOS && !canInstall && (
        <div className={styles.installedText}>
          📲 Para instalar: toque em <strong>Compartilhar</strong> →{" "}
          <strong>Adicionar à Tela de Início</strong>
        </div>
      )}

    </div>
  );
}